module.exports = __webpack_public_path__ + "media/packs/images/flags/SL-7c5a8f1a28a4a2fa938746a5ad87aed6.svg";